import { company } from './helper/ValidatorRules'

const companyValidator = {
  getMessage: () => 'Sorry, only letters, numbers (0-9), and symbols (. , - \') are allowed.',
  validate: value => {
    return {
      valid: company(value),
      data: {
        required: true
      }
    }
  }
}

export default companyValidator
